// Currently supported media item categories for upload.
// This is a subset of the categories defined in the backend, and can be expanded in the future as needed.
export enum MediaItemCategory {
  /** Unspecified category. */
  CATEGORY_UNSPECIFIED,
  /** Cover photo. A location has only one cover photo. */
  COVER,
  /** Profile photo. A location has only one profile photo. */
  PROFILE,
}
